<template>
  <Base icon="mdi-office-building" :satisfied="groupSatisfied || requirement.satisfied" tooltip>
    <span> {{ requirement.value }} months </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }} have
      {{ requirement.negative ? 'no more than' : 'at least' }}
      {{ requirement.value }} months of experience
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
    groupSatisfied: { type: Boolean },
  },
}
</script>
